import React from "react";
import { inject, observer } from "mobx-react";
import { StoreCalculationService } from "../../../services/services/storeCalculationService";
import "./storeCalculationPopupContent.scss";
import { Popup } from "../../sharedComponents/popup/popup";
import StoreCalculationPopupContent from "./storeCalculationPopupContent";
import { ClientStore } from "../../../stores/clientStore";
import { UserStore } from "../../../stores/userStore";
import { UserRole } from "../../../helpers/userRole";
import { CalculateStore } from "../../../stores/calculateStore";

interface StoreCalculationPopupProps {
  isOpen: boolean;
  storeCalculationService?: StoreCalculationService;
  clientStore?: ClientStore;
  calculateStore?: CalculateStore;
  userStore?: UserStore;
  parentCalculationId: string | undefined;
  waitForParentCalculationId: boolean;
  onClose: () => void;
}

interface StoreCalculationPopupState {
  displayPolicyUnavailable: boolean;
  saveActionClicked: boolean;
}

@inject("storeCalculationService", "clientStore", "userStore", "calculateStore")
@observer
export default class StoreCalculationPopup extends React.Component<StoreCalculationPopupProps, StoreCalculationPopupState> {
  constructor(props: StoreCalculationPopupProps) {
    super(props);

    this.state = {
      displayPolicyUnavailable: UserRole.isEurofinanceRole(this.props.userStore!.roles),
      saveActionClicked: false
    };
  }

  public componentDidUpdate(prevProps: Readonly<StoreCalculationPopupProps>, prevState: Readonly<StoreCalculationPopupState>, snapshot?: any) {
    if (this.shouldSave()) {
      this.save();
    }
  }

  public render() {
    return (
      <div className="popup">
        <Popup
          open={this.props.isOpen}
          dialogContent={
            <StoreCalculationPopupContent
              saveButtonClicked={this.state.saveActionClicked}
              saveName={this.props.storeCalculationService!.saveName}
              displayPolicyUnavailable={this.state.displayPolicyUnavailable} />
          }
          displayCancel={!this.props.storeCalculationService!.requestStatus.isPending && !this.state.saveActionClicked}
          cancelClassName={!this.props.storeCalculationService!.storeCalculationResponse.calculationId ? "cancel-button" : "ready-button"}
          cancelText={!this.props.storeCalculationService!.storeCalculationResponse.calculationId ? "Anuluj" : "Gotowe"}
          cancel={() => this.cancel()}
          displayAction={this.shouldRenderActionButton()}
          actionText={this.state.displayPolicyUnavailable ? "Kontynuuj" : "Zapisz"}
          action={() => this.action()}
        />
      </div>
    );
  }

  private shouldRenderActionButton() {
    const isError = this.props.storeCalculationService!.requestStatus.isError;
    const isPending = this.props.storeCalculationService!.requestStatus.isPending;
    const isProperResponse = this.props.storeCalculationService!.storeCalculationResponse.calculationId;
    const isCalculationPending = this.props.calculateStore!.saveCalculationRequestStatus.isPending && this.state.saveActionClicked;
    return !(isPending || isError || isProperResponse || isCalculationPending);
  }

  private action() {
    if (this.state.displayPolicyUnavailable) {
      this.setState({ displayPolicyUnavailable: false });
    } else {
      this.setState({ saveActionClicked: true });
    }
  }

  private cancel() {
    if (UserRole.isEurofinanceRole(this.props.userStore!.roles)) {
      this.setState({ displayPolicyUnavailable: true });
    }
    this.props.onClose();
  }

  private save() {
    this.setState({ saveActionClicked: false });
    this.props.storeCalculationService!.saveName.validate();

    if (!this.props.storeCalculationService!.saveName.errorMessage) {
      this.props.storeCalculationService!.saveCalculationAndProposal();
    }
  }

  private shouldSave() {
    return !this.props.calculateStore!.saveCalculationRequestStatus.isPending &&
      this.parentCalculationIdIsCorrectly() && this.state.saveActionClicked;
  }

  private parentCalculationIdIsCorrectly() {
    return !!(this.props.waitForParentCalculationId && this.props.parentCalculationId) || !this.props.waitForParentCalculationId;
  }
}
